// src/api/timesheets.js

import {get, post, patch, postFormData} from "@/lib/fetcher"

/**
 * Fetch a single timesheet from the API by job slug
 */

export async function fetchCandidateProfile(){
    return await get ('/candidates/profile')
}

export async function patchCandidatePersonalInfo(data){
    return await patch('/candidates/profile/update_personal_info', null, data)
}

export async function postCandidateCompliance(complianceTypeId, document){
    return await postFormData('/candidates/profile/upload_compliance', {compliance_type:complianceTypeId, document:document})
}

export async function postCandidateCv (cv){
    return await postFormData('/candidates/profile/upload_cv', {document:cv})
}

export async function patchCandidateQuestionnaireAnswers(answers){
    return await patch ('/candidates/profile/update_questionnaire_answers', null, {answers:answers})
}

/**
 * Submit or update a timesheet to the API
 */
// export async function submitTimesheet(id,data) {
//     return await patch(`/api/v1/candidates/timesheets`, id,data)
// }
